import { ValidateRule } from '@/coreDomainsModule/constant/validateRules';
import { FilterType } from '@/coreDomainsModule/entities/filter';
import { TableContentHeader } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';

/**
 * フォームに現れるフィールド項目名
 */
export const formOptionsAggregateBusiness = [
  'warehouseNumber',
  'warehouseName',
  'supplierNumber',
  'supplierName',
  'businessNumber',
  'businessName',
  'package',
  'unit',
  'manufacturer',
  'leadTime',
  'leadTimeUnit',
  'MOQ',
  'stdInventoryIndicesMin',
  'stdInventoryIndicesMax',
  'stdInventoryIndicesUnit',
] as const;

export const formOptionsBusiness = ['customerNumber', 'customerName', 'salesDestinationNumber', 'salesDestinationName', 'endUser'] as const;

export const addableOption = [];

export const unitOptions = ['月', '週', '日'];

export const unitOptionsMapping = { month: '月', week: '週', day: '日' };

export const validateRuleKeyMap = {
  warehouseNumber: [ValidateRule.Required],
  warehouseName: [ValidateRule.Required],
  supplierNumber: [ValidateRule.Required],
  supplierName: [ValidateRule.Required],
  businessNumber: [ValidateRule.Required],
  businessName: [ValidateRule.Required],
  package: [ValidateRule.Required],
  unit: [],
  manufacturer: [],
  leadTime: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber],
  leadTimeUnit: [ValidateRule.Required],
  MOQ: [ValidateRule.HalfWidthRealNumber],
  stdInventoryIndicesMin: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber],
  stdInventoryIndicesMax: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber],
  stdInventoryIndicesUnit: [ValidateRule.Required],
  customerNumber: [ValidateRule.Required],
  customerName: [ValidateRule.Required],
  salesDestinationNumber: [ValidateRule.Required],
  salesDestinationName: [ValidateRule.Required],
  endUser: [],
} as const;

/**
 * セレクトボックスの入力値をSelectInputのFilterTypeの値に変換する
 * @param key - セレクトボックスの入力値
 */
export const keyMappingForSelectInput: { [key: string]: FilterType } = {
  warehouseNumber: 'WAREHOUSE_CODE',
  warehouseName: 'WAREHOUSE',
  supplierNumber: 'SUPPLIER_CODE',
  supplierName: 'SUPPLIER_NAME',
  businessNumber: 'BUSINESS_CODE',
  businessName: 'BUSINESS_NAME',
  package: 'PACKAGE_AMOUNT',
  manufacturer: 'MANUFACTURER',
  leadTimeUnit: 'LEAD_TIME_UNIT',
  stdInventoryIndicesUnit: 'STD_INVENTORY_INDICES_UNIT',
  customerNumber: 'CUSTOMER_CODE',
  customerName: 'CUSTOMER_NAME',
  salesDestinationNumber: 'SALES_DESTINATION_CODE',
  salesDestinationName: 'SALES_DESTINATION_NAME',
  endUser: 'END_USER',
} as const;

/**
 * 入力フォームのタイプ
 */
export const inputTypeKeyMap = {
  warehouseNumber: 'select',
  warehouseName: 'select',
  supplierNumber: 'select',
  supplierName: 'select',
  businessNumber: 'select',
  businessName: 'select',
  package: 'select',
  unit: 'text',
  manufacturer: 'select',
  leadTime: 'text',
  leadTimeUnit: 'selectUnit',
  MOQ: 'text',
  stdInventoryIndicesMin: 'text',
  stdInventoryIndicesMax: 'text',
  stdInventoryIndicesUnit: 'selectUnit',
  customerNumber: 'select',
  customerName: 'select',
  salesDestinationNumber: 'select',
  salesDestinationName: 'select',
  endUser: 'select',
} as const;

export const editIndividualBusinessContentHeader: TableContentHeader = {
  contentProperties: [
    {
      key: 'businessId',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessId'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'businessNumber',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumber'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'editBusinessCustomerName',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerName'], propertyType: 'string' },
    },
    {
      key: 'editBusinessSalesDestinationName',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['salesDestinationName'], propertyType: 'string' },
    },
    {
      key: 'manufacturer',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['manufacturer'], propertyType: 'string' },
    },
    {
      key: 'endUser',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['endUser'], propertyType: 'string' },
    },
    {
      key: 'businessUpdateAt',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['updateAt'], propertyType: 'IDate' },
    },
    {
      key: 'editBusiness',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: false,
      },
      propertyPath: { paths: [], propertyType: 'string' },
      headerWidth: 94,
    },
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: true,
  },
};

export const editIndividualBusinessChildContentHeader: TableContentHeader = {
  contentProperties: [
    {
      key: 'businessId',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['businessId'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'businessNumber',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumber'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'customerName',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['customerName'], propertyType: 'string' },
    },
    {
      key: 'salesDestinationName',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['salesDestinationName'], propertyType: 'string' },
    },
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: false,
  },
};
